import http from '.'

export const dashboard = ()=>{
    return http.get('/dashboard')
}